let triggered = false;

// /* ===============================
//  Css Lazyload
// ================================ */

function loadLazyCSS() {
  if (window.LAZY_CSS_TRIGGERED) return;
  window.LAZY_CSS_TRIGGERED = true;

  const lazyCSSFiles = window.LAZY_CSS_FILES || [];

  lazyCSSFiles.forEach(href => {
    if (document.querySelector('link[href="' + href + '"]')) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'all';
    document.head.appendChild(link);
  });
}



/* ===============================
 Master Initializer
================================ */
function runAllDeferredFeatures() {
  if (triggered) return;
  triggered = true;

  loadLazyCSS();

}

/* ===============================
 Interaction-based Trigger
================================ */
(function () {
  ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'].forEach(evt => {
    window.addEventListener(evt, runAllDeferredFeatures, {
      once: true,
      passive: true
    });
  });
  
  ['facet:update', 'theme:loading:end'].forEach(evt => {
    window.addEventListener(evt, () => {
      setTimeout(() => {
        triggered = false; // allow re-run
        runAllDeferredFeatures();
      }, 100);
    });
  });
})();

/* ===============================
 Initial Trigger
================================ */
initProductSwipers();
/* ===============================
 Delayed After-Load Trigger
================================ */
function onPageFullyLoaded(cb) {
  if (document.readyState === 'complete') {
    cb();
  } else {
    window.addEventListener('load', cb);
  }
}

onPageFullyLoaded(function () {
  initProductSwipers();
});

